import type { FinancialAccount } from "./types";

export const isCredit = (account: FinancialAccount) =>
  account.balance?.creditLimit != null ||
  account.accountType === "CHARGE" ||
  account.accountType === "CREDIT";

export function availableBalance(
  accounts: FinancialAccount[],
  credit: boolean,
): number | undefined {
  const matching = accounts.filter((account) => isCredit(account) === credit);
  if (
    matching.some(
      (account) => !account.available || account.balance?.available == null,
    )
  )
    return undefined;
  return matching.reduce(
    (sum, account) => sum + (account.balance?.available ?? 0),
    0,
  );
}
